import { render, staticRenderFns } from "./create_theme.vue?vue&type=template&id=4cca35aa&scoped=true"
import script from "./create_theme.vue?vue&type=script&lang=js"
export * from "./create_theme.vue?vue&type=script&lang=js"
import style0 from "./create_theme.vue?vue&type=style&index=0&id=4cca35aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cca35aa",
  null
  
)

export default component.exports